import styles from './Modal.module.scss'
import { Modal } from '@mantine/core';

interface PhotoModalProps {
    opened: boolean;
    close: () => void;
    onButtonClick: () => void;
    src: string | undefined;
    label?: string;
}

const PhotoModal = ({ opened, close, onButtonClick, src, label, ...rest }: PhotoModalProps) => {


    return (
        <Modal opened={opened} onClose={close} title="Captured Photo" centered>
            <div className={styles.photoModal}>
                <img src={src} alt={'Captured Image'} className={styles.photo} />
                <p className={styles.measurement}>{label ? label : "Captured Photo"}</p>
                <button onClick={onButtonClick} className={styles.dangerButton}>Delete Photo</button>
            </div>
        </Modal>
    );
};

export default PhotoModal;
